import shopinstance from "./util/shop_util";

const shopServer = {
    // 获取商品详情
    async GetGoodsDetail(Goodsid){
        try{
            const response = await shopinstance.get(`/${Goodsid}`)
            return response; 
        } catch(error){
            console.log(error)
        }
    },

    async GetGoodsList(params){
        try{
            const response = await shopinstance.get('/search', { params })
            return response;
        } catch(error){
            console.log(error)
        }
    },

    async GetGoodsCategory(params = {}){
        try{
            const response = await shopinstance.get('/type', { params })
            return response; 
        } catch(error){
            console.log(error) 
        }
    }
}

export default shopServer